import { apiFetch } from "./api";
import { CandidateListResponse, CandidateDetail, LinkedInExperienceResponse } from "../types/fyo";

export interface CandidateFilters {
  name?:          string;
  state?:         string;
  country?:       string;
  scrape_status?: string;
  pause_reason?:  string;
  no_linkedin?:   boolean;
  limit?:         number;
  offset?:        number;
}

export function fetchCandidates(filters: CandidateFilters = {}): Promise<CandidateListResponse> {
  const q = new URLSearchParams();
  if (filters.name)          q.set("name",          filters.name);
  if (filters.state)         q.set("state",         filters.state);
  if (filters.country)       q.set("country",       filters.country);
  if (filters.scrape_status) q.set("scrape_status", filters.scrape_status);
  if (filters.pause_reason)  q.set("pause_reason",  filters.pause_reason);
  if (filters.no_linkedin)   q.set("no_linkedin",   "true");
  q.set("limit",  String(filters.limit  ?? 50));
  q.set("offset", String(filters.offset ?? 0));
  return apiFetch(`/candidates?${q}`);
}

export function fetchCandidateDetail(id: number | string): Promise<CandidateDetail> {
  return apiFetch(`/candidates/${id}`);
}

export function patchCandidate(
  id: number | string,
  payload: { linkedin_url?: string; changed_by: string; [key: string]: any },
): Promise<CandidateDetail> {
  return apiFetch(`/candidates/${id}`, { method: "PATCH", body: JSON.stringify(payload) });
}

export function fetchLinkedinExperience(id: number | string): Promise<LinkedInExperienceResponse> {
  return apiFetch(`/candidates/${id}/linkedin-experience`);
}
